import { useEffect } from 'react';
import { useBreadcrumb } from '../layouts/BreadcrumbContext';

export default function useBreadcrumbSetup(items = []) {
  const { setBreadcrumb, clearBreadcrumb } = useBreadcrumb();

  useEffect(() => {
    if (items.length > 0) {
      setBreadcrumb(items);
    } else {
      clearBreadcrumb();
    }
  }, []);
}
